import { render, staticRenderFns } from "./close_sale.vue?vue&type=template&id=3587042a&scoped=true&"
import script from "./close_sale.vue?vue&type=script&lang=js&"
export * from "./close_sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587042a",
  null
  
)

export default component.exports